import api from '@http/api';

export interface IGetAllProjetosTable {
  id: number;
  nome: string;

}

export interface IGetAllProjetos {
  error: boolean;
  response?: IGetAllProjetosTable[];
}

export interface IRequestProjeto {
  nome: string;
  fundoId: number;
}

export interface IGetAllFundos {
  id: number;
  nome: string;
}

class Services {
  public async GetAllFundos() {
    return await api
      .get<IGetAllFundos[]>(`/api/fundos/GetAll`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async CreateProjeto(data: IRequestProjeto) {
    return await api
      .post('/api/projetos/Create', data)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

}

export default Services;
